import { style } from "typestyle";

export const iconMirrorringXClassName = style({
    transform: 'scaleX(-1)'
});

export const iconMirrorringYClassName = style({
    transform: 'scaleY(-1)'
});
